/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2024-2026 OKTET LTD */

const analyticsEventNames = {
	dashboardModeChange: 'dashboard_mode_change',
	dashboardDateChange: 'dashboard_date_change',
	dashboardTodayClick: 'dashboard_today_click',
	dashboardSearchApply: 'dashboard_search_apply',
	dashboardAutoReloadToggle: 'dashboard_auto_reload_toggle',
	dashboardTvModeToggle: 'dashboard_tv_mode_toggle',
	dashboardManualRefresh: 'dashboard_manual_refresh',
	dashboardCopyShortUrl: 'dashboard_copy_short_url',
	dashboardRowExpandToggle: 'dashboard_row_expand_toggle',
	dashboardTableLinkClick: 'dashboard_table_link_click',
	runModeToggle: 'run_mode_toggle',
	runOpenLogClick: 'run_open_log_click',
	runCopyDetailsCopy: 'run_copy_details_copy',
	runCopyShortUrl: 'run_copy_short_url',
	runTableSortChange: 'run_table_sort_change',
	runTableToolbarColumnsOpen: 'run_table_toolbar_columns_open',
	runTableToolbarColumnVisibilityToggle:
		'run_table_toolbar_column_visibility_toggle',
	runTableToolbarPreviewNok: 'run_table_toolbar_preview_nok',
	runTableToolbarOpenNok: 'run_table_toolbar_open_nok',
	runTableToolbarReset: 'run_table_toolbar_reset',
	runTableRequirementsChange: 'run_table_requirements_change',
	runTableRequirementsSubmit: 'run_table_requirements_submit',
	runTableRequirementsReset: 'run_table_requirements_reset',
	runTableTreeToggle: 'run_table_tree_toggle',
	runTableHistoryLinkClick: 'run_table_history_link_click',
	runTableBadgeClick: 'run_table_badge_click',
	resultTableToolbarToggle: 'result_table_toolbar_toggle',
	resultTableReferenceToggle: 'result_table_reference_toggle',
	resultTableFilterChange: 'result_table_filter_change',
	resultTableFiltersReset: 'result_table_filters_reset',
	resultTableLinkClick: 'result_table_link_click',
	logModeToggle: 'log_mode_toggle',
	logLegacyToggle: 'log_legacy_toggle',
	logTreeNokToggle: 'log_tree_nok_toggle',
	logTreeScrollToFocus: 'log_tree_scroll_to_focus',
	logTreeRunLogClick: 'log_tree_run_log_click',
	logTreeNodeClick: 'log_tree_node_click',
	logPageChange: 'log_page_change',
	logLineBookmark: 'log_line_bookmark',
	logCopyShortUrl: 'log_copy_short_url',
	logLinkToRunClick: 'log_link_to_run_click',
	logLinkToMeasurementsClick: 'log_link_to_measurements_click',
	measurementsModeChange: 'measurements_mode_change',
	measurementsChartSelect: 'measurements_chart_select',
	measurementsCombinedOpen: 'measurements_combined_open',
	measurementsCombinedReset: 'measurements_combined_reset',
	measurementsCombinedRemove: 'measurements_combined_remove',
	measurementsChartToolbarAction: 'measurements_chart_toolbar_action',
	measurementsExport: 'measurements_export',
	measurementsLinkToRunClick: 'measurements_link_to_run_click',
	measurementsLinkToLogClick: 'measurements_link_to_log_click',
	measurementsCopyShortUrl: 'measurements_copy_short_url',
	historyModeChange: 'history_mode_change',
	historyGlobalSearchSubmit: 'history_global_search_submit',
	historyRefreshClick: 'history_refresh_click',
	historyResetFiltersClick: 'history_reset_filters_click',
	historySubstringFilterApply: 'history_substring_filter_apply',
	historyLinkClick: 'history_link_click',
	historyLinkComponentClick: 'history_link_component_click',
	historyCopyShortUrl: 'history_copy_short_url',
	runDiffViewToggle: 'run_diff_view_toggle',
	runDiffNavigationClick: 'run_diff_navigation_click',
	runMultipleSelectedRunChange: 'run_multiple_selected_run_change',
	runMultipleModeToggle: 'run_multiple_mode_toggle',
	runMultipleNavigationClick: 'run_multiple_navigation_click',
	runMultipleCopyShortUrl: 'run_multiple_copy_short_url',
	runReportOpen: 'run_report_open',
	importModalOpen: 'import_modal_open',
	importRunsSubmit: 'import_runs_submit',
	importEventsFilterApply: 'import_events_filter_apply',
	importEventsFilterReset: 'import_events_filter_reset',
	importTaskLogOpen: 'import_task_log_open',
	configsCreateSubmit: 'configs_create_submit',
	configsUpdateSubmit: 'configs_update_submit',
	configsLifecycleAction: 'configs_lifecycle_action',
	adminUsersCreateSubmit: 'admin_users_create_submit',
	adminUsersUpdateSubmit: 'admin_users_update_submit',
	adminUsersDeactivateConfirm: 'admin_users_deactivate_confirm',
	adminAnalyticsFiltersApply: 'admin_analytics_filters_apply',
	netPacketFilterApply: 'net_packet_filter_apply',
	netPacketSelectPacket: 'net_packet_select_packet',
	netPacketBacklinkClick: 'net_packet_backlink_click',
	authLoginSubmit: 'auth_login_submit',
	authForgotPasswordSubmit: 'auth_forgot_password_submit',
	authResetPasswordSubmit: 'auth_reset_password_submit',
	authEmailActivationResult: 'auth_email_activation_result',
	notFoundGoBackClick: 'not_found_go_back_click',
	notFoundGoDashboardClick: 'not_found_go_dashboard_click',
	helpPageOpen: 'help_page_open',
	developersFlowerOpen: 'developers_flower_open',
	runsFormSubmit: 'runs_form_submit',
	runsFormReset: 'runs_form_reset',
	runsFormTagsEdit: 'runs_form_tags_edit',
	runsTableTagClick: 'runs_table_tag_click',
	runsRowSelectionChange: 'runs_row_selection_change',
	runsSelectionReset: 'runs_selection_reset',
	runsSelectionAction: 'runs_selection_action',
	runsCopyShortUrl: 'runs_copy_short_url'
} as const;

export { analyticsEventNames };
